import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { withStyles, Tooltip, makeStyles, ClickAwayListener } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { u as useStyleConstants } from './globalButtonStyles-41c8af84.js';
import { s as styleConstants } from './constants-3b80be2a.js';
import './_tslib-ff3a08af.js';
import { InfoOutlined } from '@material-ui/icons';

var CustomisedTooltip = withStyles(function (theme) {
    return {
        tooltip: {
            backgroundColor: '#f5f5f9',
            color: '#353E53',
            maxWidth: 220,
            fontSize: '14px',
            border: '1px solid #dadde9'
        }
    };
})(Tooltip);
var InformationTooltip = function (_a) {
    var information = _a.information;
    var styleConstants = useStyleConstants();
    return jsx(CustomisedTooltip, { placement: "top", title: information, children: jsx(InfoIcon, { style: { color: styleConstants.colors.primaryColor } }) });
};
//
var useCustomTooltipStyles = makeStyles(function (theme) {
    return {
        tooltip: {
            backgroundColor: '#f5f5f9',
            color: styleConstants.colors.darkBlue,
            width: 280,
            border: '1px solid #dadde9',
            zIndex: 9999
        }
    };
});
var CustomTooltip = function (_a) {
    var tooltipText = _a.tooltipText;
    var classes = useCustomTooltipStyles();
    var _b = useState(false),
        open = _b[0],
        setOpen = _b[1];
    return jsx(ClickAwayListener, { onClickAway: function () {
            return setOpen(false);
        }, children: jsx(CustomisedTooltip, { title: tooltipText, placement: "bottom-end", disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, open: open, onClose: function () {
                return setOpen(false);
            }, classes: {
                tooltip: classes.tooltip
            }, children: jsx(InfoOutlined, { color: "primary", style: { fontSize: 20 }, onClick: function () {
                    return setOpen(true);
                } }) }) });
};

export { CustomisedTooltip as C, InformationTooltip as I, CustomTooltip as a, useCustomTooltipStyles as u };
